<template>
	<!-- Skip Link for Keyboard Navigation — teleported before v-main for first-focus order -->
	<Teleport to="#skip-links-portal">
		<a href="#main-content" class="skip-link" @click.prevent="() => { const el = document.getElementById('main-content'); if (el) el.focus(); }">Skip to main content</a>
	</Teleport>
    <div id="main-content" tabindex="-1" class="bg-color-granite pb-10" role="main" aria-label="Redeem Your Rewards page content">
		<div class="d-flex justify-center align-center w-100 position-relative">
			<v-img class="w-100 h-100"			
				:height="199"
				aspect-ratio="16/9"
				src="https://dellpartnerincentives.com/siteassets/Images/HomePartner/Banner/bgRISE2.jpg"
			></v-img>
			<div class="position-absolute page-header">
				<h1><LanguagePlaceholder default-text="Redeem Your Rewards" /></h1>
			</div>			
		</div>
        <div class="bg-color-granite w-100 h-100">
            <div class="bg-color-quartz w-100 h-100 my-2">
                <v-row no-gutters class="d-flex justify-center w-100 pa-0 pt-3 bg-color-dell-blue tx-color-white">
                    <v-col cols="10" class="d-flex flex-column justify-start w-100 pa-0 py-8 tx-font-normal tx-font-size20">  
                        <v-row no-gutters class="mb-2">
                          <LanguagePlaceholder is-html default-text="To redeem the rewards you earned in the last incentive period, you must convert them into <b>e-vouchers</b> to spend with your chosen distributors." />
                        </v-row>
                        <v-row no-gutters class="mb-2">
                          <LanguagePlaceholder is-html default-text="You can earn up to <b>$15,000 per incentive period</b> and split your rewards across a <b>maximum of five e-vouchers.</b>" />
                        </v-row>
                        <v-row no-gutters class="mb-7">
                          <LanguagePlaceholder is-html default-text="E-vouchers must be <b>used in full</b> to purchase Dell Technologies products. The value of your order must be <b>greater than the value of your e-voucher</b>, so please keep this in mind when selecting your vouchers." />
                        </v-row>
                        <v-row no-gutters class="mb-2 tx-font-normal tx-font-size32">
                          <LanguagePlaceholder is-html default-text="5 Steps to redeem your voucher:" />
                        </v-row>            
                        <v-row no-gutters class="mb-2  tx-font-normal tx-font-size16">
                          <LanguagePlaceholder is-html default-text="<b>Step 1</b>. Confirm your total rewards balance available to redeem as an e-voucher.<br><b>Step 2</b>. Select your preferred distributors from the dropdown menu. You can redeem with multiple distributors.<br><b>Step 3</b>. Enter the amount you would like to redeem.<br><b>Step 4</b>. Click “Redeem” to complete the process.<br><b>Step 5</b>. Any remaining reward balance will be automatically redeemed.<br>" />
                        </v-row>                        
                    </v-col>
                </v-row>
            </div>
            <div class="bg-color-granite w-auto h-100 my-2 mx-10" >
                <v-row no-gutters class="d-flex justify-center w-100 pa-0">
                    <v-col cols="11" class="bg-color-quartz d-flex justify-center w-100 pa-0">  
                        <div class="bg-color-quartz tx-font-bolder pa-2 d-flex justify-center flex-column w-100 pa-0 ma-5">
                            <v-card class="elevation-0 w-100 pa-5" color="#0D2155">
                                <v-card-text>
                                    <v-row v-if="redemptionSummary.openingBalance >= 50" class="tx-font-normal tx-font-size16">
                                        <LanguagePlaceholder is-html default-text="<b>Please note:</b> If your e-voucher balance is zero and you have no qualifying sales from the previous quarter resulting in a credit note, you will not be eligible to redeem e-vouchers." />
                                    </v-row>
                                    <v-row v-if="redemptionSummary.openingBalance < 50" class="tx-font-normal tx-font-size16">
                                        <LanguagePlaceholder is-html default-text='<b>Please note:</b> You may only redeem your rewards for an E-voucher if you have a rewards balance of <b class="tx-font-bolder">$50</b> or more. If you have not reached the minimum balance of <b class="tx-font-bolder">$50</b>, your rewards will automatically be banked/deferred for one quarter.' />
                                    </v-row>
                                    <v-row class="tx-font-normal tx-font-size16 pt-2">
                                        <LanguagePlaceholder is-html default-text="Please <route route-name='contact-us' style='text-decoration: underline;'>Contact Support</route> should you need further clarification." />
                                    </v-row>                                    
                                </v-card-text>                        
                            </v-card>
                            <!-- <v-card v-if="redemptionWindowOpen === false" class="elevation-0 w-100 mt-5 pa-2" color="#FFFFFF">
                                <v-card-text>
                                    <v-row class=" tx-font-bolder tx-font-size18">
                                        <LanguagePlaceholder is-html default-text="Please note the Q{{P1}} FY{{P2}} redemption period is closed. If you have not redeemed your voucher yet, we are doing the work for you. Stay tuned to receive your voucher via email and check your Rewards Paid page. <route route-name='contact-us' class='route' style='text-decoration: underline;'>Contact Support</route> with any questions you may have. We will notify you once the Q{{P4}} FY{{P5}} redemption period is open." :find-and-replace="qfyValue" />         
                                    </v-row>                                    
                                </v-card-text>                        
                            </v-card> -->
                        </div>
                    </v-col>
                </v-row>                
            </div>
            <div v-if="redemptionWindowOpen === true" class="bg-color-granite w-auto h-100 my-2 mx-10" >
                <v-row no-gutters class="d-flex justify-center w-100 pa-0">
                    <v-col cols="11" class="bg-color-quartz">
                        <div class="bg-color-quartz tx-font-bolder ma-0 pa-0">
                            <div>
                                <div class="ma-4" v-if="redemptionSummary.openingBalance < 50 || redemptionSummary.banked > 0">
                                    <v-row justify="space-around" align-content="stretch">
                                        <v-col cols="4">
                                            <v-card class="h-100 elevation-0 text-center py-16 rounded-lg" style="background-color: #0672cb;">
                                                <div class="d-flex justify-center align-center flex-column mb-6">
                                                    <v-sheet class="ma-2 pa-2 bg-transparent text-white text-h4 font-weight-bold">{{ $filters.currencyUSD(redemptionSummary.openingBalance) }}</v-sheet>
                                                    <v-sheet class="ma-2 pa-2 bg-transparent text-white "><LanguagePlaceholder
                                                        default-text="Rewards you earned last incentive period" /></v-sheet>
                                                </div>
                                            </v-card>
                                        </v-col>
                                        
                                        <v-col cols="4">
                                            <v-row>
                                                <v-col>
                                                    <v-card class="h-100 elevation-0 text-center py-16 rounded-lg" style="background-color: #0672cb;">
                                                        <!-- <v-btn 
                                                            icon="mdi-information" 
                                                            color="white"
                                                            density="compact"
                                                            @click="showBankedInfo = true"
                                                            class="position-absolute top-0 right-0 bg-white mt-2 me-2 elevation-10"
                                                        ></v-btn> -->
                                                        <div class="d-flex justify-center align-center flex-column">
                                                            <v-sheet class="ma-2 pa-2 bg-transparent text-white text-h4 font-weight-bold">{{ $filters.currencyUSD(qualifyBalance) }}</v-sheet>
                                                            <v-sheet class="ma-2 pa-2 bg-transparent text-white "><LanguagePlaceholder
                                                                default-text="Rewards you need to earn this incentive period to qualify for an E-Voucher" /></v-sheet>
                                                        </div>                                  
                                                    </v-card>  
                                                </v-col>
                                            </v-row>                                
                                        </v-col>     
                                        
                                        <v-col cols="4">
                                            <v-card class="elevation-0 text-white h-100 w-100 rounded-lg pt-10" style="background-color: #0672cb;">
                                                <v-row>
                                                    <v-col cols="8" class="pt-5 text-end text-subtitle-1">
                                                        <LanguagePlaceholder
                                                                default-text="Reward Balance" />
                                                    </v-col>
                                                    <v-col class="pe-10 pt-5 text-end font-weight-bold" >
                                                        {{ $filters.currencyUSD(redemptionSummary.balance) }}
                                                    </v-col>
                                                </v-row> 
                                                <v-row>
                                                    <v-col cols="8" class="text-end text-subtitle-1">
                                                        <LanguagePlaceholder
                                                                default-text="Banked Reward Balance" />
                                                    </v-col>
                                                    <v-col class="pe-10 px-5 text-end font-weight-bold">
                                                        {{ $filters.currencyUSD(redemptionSummary.banked) }}
                                                    </v-col>
                                                </v-row> 
                                                <v-row style="background-color: #0d2154;">
                                                    <v-col cols="8" class="text-end text-subtitle-1 pb-6">
                                                        <LanguagePlaceholder
                                                                default-text="Total Balance" />
                                                    </v-col>
                                                    <v-col class="pe-10 pb-4 text-end font-weight-bold">
                                                        {{ $filters.currencyUSD(redemptionSummary.balance + redemptionSummary.banked) }}
                                                    </v-col>
                                                </v-row> 
                                            </v-card>  
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="4">
                                            <v-card class="h-100 elevation-0 text-center py-16 rounded-lg" style="background-color: #0672cb;">
                                                <div class="d-flex justify-center align-center flex-column">
                                                    <v-sheet class="ma-2 pa-2 bg-transparent text-white text-h4 font-weight-bold">{{ $filters.currencyUSD(redemptionSummary.rewardsRedeemed) }}</v-sheet>
                                                    <v-sheet class="ma-2 pa-2 bg-transparent text-white "><LanguagePlaceholder
                                                        default-text="Redeemed this incentive period" /></v-sheet>
                                                </div>
                                            </v-card>
                                        </v-col>
                                        
                                        <v-col cols="4">
                                            <v-card class="h-100 elevation-0 text-center py-16 rounded-lg" style="background-color: #0672cb;">
                                                <div class="d-flex justify-center align-center flex-column">
                                                    <v-sheet class="ma-2 pa-2 bg-transparent text-white text-h4 font-weight-bold">{{ redemptionSummary.eVouchersRedeemed }}</v-sheet>
                                                    <v-sheet class="ma-2 pa-2 bg-transparent text-white "><LanguagePlaceholder
                                                        default-text="Total E-Vouchers Redeemed" /></v-sheet>
                                                </div>                                  
                                            </v-card>  
                                        </v-col>
                                    </v-row>
                                </div>
                                <div class="mt-4 mb-4" v-if="redemptionSummary.openingBalance >= 50 && redemptionSummary.banked === 0">
                                    <v-row justify="space-around" align-content="stretch">
                                        <v-col cols="4">
                                            <v-card class="h-100 elevation-0 text-center py-16 rounded-lg" style="background-color: #0672cb;">
                                                <div class="d-flex justify-center align-center flex-column mb-6">
                                                    <v-sheet class="ma-2 pa-2 bg-transparent text-white text-h4 font-weight-bold">{{ $filters.currencyUSD(redemptionSummary.openingBalance) }}</v-sheet>
                                                    <v-sheet class="ma-2 pa-2 bg-transparent text-white "><LanguagePlaceholder
                                                        default-text="Rewards you earned last incentive period" /></v-sheet>
                                                </div>
                                            </v-card>
                                        </v-col>

                                        <v-col cols="4">
                                            <v-card class="h-100 elevation-0 text-center py-16 rounded-lg" style="background-color: #0672cb;">
                                                <div class="d-flex justify-center align-center flex-column">
                                                    <v-sheet class="ma-2 pa-2 bg-transparent text-white text-h4 font-weight-bold">{{ $filters.currencyUSD(redemptionSummary.rewardsRedeemed) }}</v-sheet>
                                                    <v-sheet class="ma-2 pa-2 bg-transparent text-white "><LanguagePlaceholder
                                                        default-text="Redeemed this incentive period" /></v-sheet>
                                                </div>
                                            </v-card>
                                        </v-col>

                                        <v-col cols="4">
                                            <v-card class="h-100 elevation-0 text-center py-16 rounded-lg" style="background-color: #0672cb;">
                                                <div class="d-flex justify-center align-center flex-column">
                                                    <v-sheet class="ma-2 pa-2 bg-transparent text-white text-h4 font-weight-bold">{{ $filters.currencyUSD(redemptionSummary.balance) }}</v-sheet>
                                                    <v-sheet class="ma-2 pa-2 bg-transparent text-white "><LanguagePlaceholder
                                                        default-text="Balance" /></v-sheet>
                                                </div>
                                            </v-card>
                                        </v-col>                         
                                    </v-row>
                                    <v-row>                            
                                        <v-col cols="4">
                                            <v-card class="h-100 elevation-0 text-center py-16 rounded-lg" style="background-color: #0672cb;">
                                                <div class="d-flex justify-center align-center flex-column">
                                                    <v-sheet class="ma-2 pa-2 bg-transparent text-white text-h4 font-weight-bold">{{ redemptionSummary.eVouchersRedeemed }}</v-sheet>
                                                    <v-sheet class="ma-2 pa-2 bg-transparent text-white "><LanguagePlaceholder
                                                        default-text="Total E-Vouchers Redeemed" /></v-sheet>
                                                </div>                                  
                                            </v-card>  
                                        </v-col>
                                    </v-row>
                                </div>
                            </div>    
                        </div>
                    </v-col>                    
                </v-row>
            </div>
            <div v-if="redemptionWindowOpen === true && hasZeroBalance === false"  class="bg-color-granite w-auto h-100 my-2 mx-10" >
                <v-row no-gutters class="d-flex justify-center w-100 pa-0">
                    <v-col cols="11" class="bg-color-quartz">
                        <v-row
                            justify="space-around" 
                            align-content="stretch">
                            <v-card class="elevation-0 w-100 ma-3" color="#EEEEEE" >
                                <v-card-text>
                                    <v-container>
                                        <v-row class="pa-3">
                                            <v-select clearable @click:clear="clickClearDistributor" class=""
                                                v-model="selectedDistributor" return-object
                                                item-title="description" item-value="affinityId" :items="distributors"
                                                variant="outlined">
                                                <template v-slot:label>
                                                    <LanguagePlaceholder default-text="Select Distributor" />
                                                </template>
                                            </v-select>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <v-text-field 
                                                    @blur="replaceCharacters" 
                                                    v-model="redeemAmountUSD" 
                                                    variant="outlined" 
                                                    :rules="redemptionAmountRules">
                                                    <template v-slot:label>
                                                        <LanguagePlaceholder default-text="Enter $ to redeem" />
                                                    </template>
                                                </v-text-field>
                                            </v-col>
                                            <v-col>
                                                <v-text-field v-model="placeholder" readonly variant="outlined" label="Conversion">
                                                    <template v-slot:default>
                                                    {{ redeemAmountLocalCurrency }} 
                                                    </template>
                                                    <template v-slot:label>
                                                        <LanguagePlaceholder default-text="Conversion" />
                                                    </template>
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn :disabled="inputDataVerified == false" width="100" @click="showConfirmation = true" color="#0672cb" variant="elevated" class="text-none ma-2">
                                        <LanguagePlaceholder default-text="Redeem" />
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-row>
                    </v-col>
                </v-row>
            </div>
        </div>

        <!-- <v-dialog v-model="showDataDelayNotice" width="650" scrollable>
            <v-card>
                <v-toolbar color="#0d2155">
                    <v-toolbar-title><LanguagePlaceholder default-text="Important Notice" /></v-toolbar-title>
                </v-toolbar>
                <v-card-text class="pa-4">
                    <p class="my-2 general-text tx-font-bolder">
                        <LanguagePlaceholder default-text="Please note that there is a delay in the data update on RISE, we will inform you as soon as Redemptions are open." />
                    </p>
                </v-card-text>
                <v-card-actions class="border-t-thin">
                    <v-spacer></v-spacer>
                    <v-btn @click="showDataDelayNotice = false" width="100" color="#055699" variant="elevated"><LanguagePlaceholder default-text="Close" /></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog> -->

        <v-dialog v-model="showConfirmation" width="650" scrollable>
          <v-card>
              <v-toolbar color="#0d2155">
                  <v-toolbar-title><LanguagePlaceholder default-text="E-Voucher Confirmation" /></v-toolbar-title>
              </v-toolbar>
              <v-card-text class="pa-4">
                    <p class="my-2 general-text" style="color: red;">
                        <LanguagePlaceholder is-html default-text="<b>Please Note: Qualcomm products are not eligible for purchase using RISE rewards</b>" />
                    </p>
                  <p class="my-2 general-text">
                      <LanguagePlaceholder default-text="You are about to redeem the following:" />
                  </p>
                  <v-text-field readonly v-model="redeemAmountUSD" variant="outlined" >
                      <template v-slot:label>                                                            	
                                      <LanguagePlaceholder is-html default-text="$ to be Redeemed:" />
                                  </template>
                  </v-text-field>
                  <v-text-field readonly v-model="selectedDistributor.distributorName" variant="outlined">
                      <template v-slot:label>                                                            	
                                      <LanguagePlaceholder is-html default-text="Distributor Name" />
                                  </template>
                  </v-text-field>
                  <v-text-field readonly v-model="redeemAmountLocalCurrency" variant="outlined">
                      <template v-slot:label>                                                            	
                                      <LanguagePlaceholder is-html default-text="E-Voucher Value" />
                                  </template>
                  </v-text-field>

              </v-card-text>
              <v-card-actions class="border-t-thin">
                  <v-btn @click="showConfirmation = false" width="100"><LanguagePlaceholder default-text="Close" /></v-btn>
                  <v-spacer></v-spacer>
                  <v-btn v-if="!redemptionSubmitted" :disabled="!inputDataVerified" width="100" @click="submitRedemption" color="#055699" variant="elevated"><LanguagePlaceholder default-text="Confirm" /></v-btn>
              </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="showSuccess" width="650" scrollable>
            <v-card class="bg-blue-darken-4">
                <v-card-text class="pa-4">
                    <p class="my-2 general-text">
                        <LanguagePlaceholder is-html default-text='Congratulations! You have successfully redeemed your rewards. Your<br>E-Voucher has been emailed to you and to your chosen distributor. To also view your voucher and to download a copy of your E-voucher please click on <route route-name="partner-rewards-paid">Rewards Paid</route> and scroll down to the bottom.' />
                    </p>
                </v-card-text>
                <v-card-actions class="border-t-thin">
                    <v-btn @click="showSuccess = false" width="100"><LanguagePlaceholder default-text="Close" /></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script setup>
import { ref, onMounted, computed, getCurrentInstance, watch  } from 'vue'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'
import { useSystemStore } from '@/stores/system'

const systemStore = useSystemStore()

const showConfirmation = ref(false)
const showSuccess = ref(false)
const showDataDelayNotice = ref(true)

const distributors = ref([])
const redemptionSummary = ref({})
const hedgeRate = ref({})
const redemptionWindowOpen = ref(false)

const redeemAmountUSD = ref(0)
const placeholder = ref(' ') // small workaround to keep the label ontop of the text-field when slot is populated
const selectedDistributor = ref(null)
const selectedQuarter = ref('')
const qfyValue = [
    { find: '{{P1}}', replace: '4'},
    { find: '{{P2}}', replace: '25'},
    { find: '{{P3}}', replace: '2025'},
    { find: '{{P4}}', replace: '1'},
    { find: '{{P5}}', replace: '26'},
    { find: '{{P6}}', replace: '2026'}
]

const redemptionSubmitted = ref(false)

const redemptionAmountError = `Minimum redemption amount is $50.00. Maximum redemption amount is the Total Balance value.`

const redemptionAmountRules = [
    value => (!!value && value >= 1 && value <= (redemptionSummary.value.balance + redemptionSummary.value.banked)) || redemptionAmountError
]

const validateAgainstRules = (value, rules) => {
    for (const rule of rules) {
        const result = rule(value);
        if (result !== true) {
            return false;
        }
    }
    return true; 
};

onMounted(() => {

    systemStore.getQuarters().then(result => {
    if (result.success) {
      selectedQuarter.value = result.quarters.find(q => q.currentRedemptionQuarter === true)?.quarter
      getRedemptionSummary()
      getDistributors()
      getHedgeRate()      
      isRedemptionWindowOpen()
    }
    }).catch(error => {
      console.log('recalculateLocalValue', error)
    })
})

const hasZeroBalance = computed(() => {
    let ret = true
    if (redemptionSummary.value.rewardsThresholdNotMet) {
        if (redemptionSummary.value.balance + redemptionSummary.value.banked < 50){
            ret = true
        } else {
            ret = false
        }
    }
    else {
        if (redemptionSummary.value.balance <= 0){
            ret = true
        } else {
            ret = false
        }
    }

    return ret
})

const qualifyBalance = computed(() => {
    if (redemptionSummary.value.balance == undefined) {
        return 50
    } 
    else if (redemptionSummary.value.banked == undefined) {
        return 50
    } 
    else {
        if (redemptionSummary.value.balance + redemptionSummary.value.banked < 50){
            return 50 - (redemptionSummary.value.balance + redemptionSummary.value.banked)
        } else {
            return 0
        }
    }
})

const getRedemptionSummary = () => {
    systemStore.getRewardsAccountData(selectedQuarter.value).then(result => {
        redemptionSummary.value = result
    })
}

const isRedemptionWindowOpen = () => {
    systemStore.getAutoRedemptionState().then(result => {
        redemptionWindowOpen.value = result.autoRedemptionState
        //redemptionWindowOpen.value = true
    }).catch(error => {
      console.log('getAutoRedemptionState', error)
    })
}

const getHedgeRate = () => {
    systemStore.getPartnerRedemptionHedgeRate().then(result => {
        hedgeRate.value = result
    })
}

const getDistributors = () => {
    systemStore.getPartnerRedemptionDistributors(selectedQuarter.value).then(result => {
        distributors.value = result.distributors == null ? [] : result.distributors
    }).catch(error => {
        console.log(error)
    })
}

const inputDataVerified = computed(() => {
    var distiId = selectedDistributor.value != null ?selectedDistributor.value.distiId : 0
    var amountUSD = parseFloat(redeemAmountUSD.value)

    if (redemptionSummary != undefined && redemptionSummary.value.balance + redemptionSummary.value.banked > 0 && amountUSD > 0 && amountUSD <= redemptionSummary.value.balance + redemptionSummary.value.banked){
        if (distiId > 0){
            return true
        } else {
            return false
        }
    } else{
        return false
    }
})

const redeemAmountLocalCurrency = computed(() => {
    var value = redeemAmountUSD.value
    var currencyCode = hedgeRate.value.currencyCode != undefined ? hedgeRate.value.currencyCode : "USD"
    var rate = hedgeRate.value.rate != undefined ? hedgeRate.value.rate : 1

    if (value === undefined){
      value = 0
    } else {
        value = parseFloat(value)
    }

    if (rate === 0) {
        rate = 1
    }

    value = value / rate

    return value.toLocaleString("en-US", {
      style: "currency",
      currency: currencyCode,
    });
})

const clickClearDistributor = () => {

}

const submitRedemption = () => {

    if (!validateAgainstRules(redeemAmountUSD.value, redemptionAmountRules)) {
        return 
    }

    var distiId = selectedDistributor.value != null ? selectedDistributor.value.distiId : 0

    if (distiId === 0) {
        return
    }

    redemptionSubmitted.value = true

    systemStore.submitRedemption(distiId, redeemAmountUSD.value).then(result => {
        if (result.success === true){
            showConfirmation.value = false
            redeemAmountUSD.value = 0
            showSuccess.value = true

            getDistributors()
            getRedemptionSummary()
        } else {
            systemStore.showMessage('There was an error processing the request, please contact support.', {color:'error'})
        }
    }).catch(error => {
        console.log(error)
    })
}

const replaceCharacters = () => {
    redeemAmountUSD.value = redeemAmountUSD.value.replace(",", ".");
}

</script>

<style scoped>


</style>